import React from 'react';
import InterruptProcessModal from '../../InterruptProcessModal/InterruptProcessModal';

const DeleteDraftModal = ({ onClose, onConfirm }) => (
    <InterruptProcessModal isOpen onClose={onClose} handleInterruption={onConfirm}>
        <InterruptProcessModal.Icon />
        <InterruptProcessModal.Heading />
        <InterruptProcessModal.Description>
            Bist Du sicher, dass Du den Entwurf dieses Profils löschen möchtest?
        </InterruptProcessModal.Description>
        <InterruptProcessModal.Footer>
            <InterruptProcessModal.Sidenote>
                Deine bisherigen Eingaben werden unwiderruflich gelöscht.
            </InterruptProcessModal.Sidenote>
            <InterruptProcessModal.Button>Profil löschen</InterruptProcessModal.Button>
        </InterruptProcessModal.Footer>
    </InterruptProcessModal>
);

export default DeleteDraftModal;
